export default __webpack_public_path__ + "static/people-homes-businesses-011ff85a1f6411ed87d55a30764f12f7.jpg";